
const priceInfo = {
    english: {
        tableHead: ['Service', 'Price'],
        groups: [
            {
                id: 0,
                title: '',
                tableBody: [
                    {
                        id: 0,
                        name: "Acupuncture/Acupressure",
                        price: '$120/55mins (Initial Visit)\n$100/50mins (Subsequent Visit)\n$70/30mins'
                    },
                    {
                        id: 1,
                        name: "Facial Acupuncture",
                        price: '$160/50mins'
                    },
                    {
                        id: 2,
                        name: "TCM Assessment (Diagnosis and prescription)",
                        price: '$40/Time'
                    },
                    {
                        id: 3,
                        name: "Moxibustion",
                        price: '$100/50mins'
                    },
                    {
                        id: 4,
                        name: "Cupping",
                        price: '$65/30mins'
                    },
                    {
                        id: 5,
                        name: "Scraping",
                        price: '$65/30mins'
                    },
                    {
                        id: 6,
                        name: "Herbal Medicine",
                        price: 'According to diagnosis'
                    }
                ]
            },
            {
                id: 1,
                title: 'Registered Massage Therapist',
                tableBody: [
                    {
                        id: 7,
                        name: "Registered Massage Therapy",
                        price: '$140 + GST/60mins\n$120 + GST/45mins\n$100 + GST/30mins'
                    }
                ]
            },
            {
                id: 2,
                title: 'Others',
                tableBody: [
                    {
                        id: 8,
                        name: "Aromatic Essential Oil Massage",
                        price: '$85 + GST/50mins'
                    },
                    {
                        id: 9,
                        name: "Tui Na Massage",
                        price: '$85 + GST/50mins'
                    },
                    {
                        id: 10,
                        name: "Traditional Head Massage",
                        price: '$85 + GST/50mins'
                    },
                    {
                        id: 11,
                        name: "Lymph Drainage Massage",
                        price: '$100 + GST/55mins'
                    },
                    {
                        id: 12,
                        name: "Hot Stone Massage",
                        price: '$150 + GST/75mins'
                    }
                ]
            }
        ]
    },
    chinese: {
        tableHead: ['项目', '价格'],
        groups: [
            {
                id: 0,
                title: '',
                tableBody: [
                    {
                        id: 0,
                        name: "针灸/推拿",
                        price: '$120/55分钟（首次）\n$100/50分钟（复诊）\n$70/30分钟'
                    },
                    {
                        id: 1,
                        name: "面部针灸",
                        price: '$160/50分钟'
                    },
                    {
                        id: 2,
                        name: "中医面诊",
                        price: '$40/次'
                    },
                    {
                        id: 3,
                        name: "艾灸",
                        price: '$100/50分钟'
                    },
                    {
                        id: 4,
                        name: "拔罐",
                        price: '$65/30分钟'
                    },
                    {
                        id: 5,
                        name: "刮痧",
                        price: '$65/30分钟'
                    },
                    {
                        id: 6,
                        name: "科学中药",
                        price: '视处方而定'
                    }
                ]
            },
            {
                id: 1,
                title: '注册按摩（RMT）',
                tableBody: [
                    {
                        id: 7,
                        name: "注册按摩",
                        price: '$140 + GST/60分钟\n$120 + GST/45分钟\n$100 + GST/30分钟'
                    }
                ]
            },
            {
                id: 2,
                title: '其它',
                tableBody: [
                    {
                        id: 8,
                        name: "精油开背",
                        price: '$85 + GST/50分钟'
                    },
                    {
                        id: 9,
                        name: "推拿按摩",
                        price: '$85 + GST/50分钟'
                    },
                    {
                        id: 10,
                        name: "传统头疗",
                        price: '$85 + GST/50分钟'
                    },
                    {
                        id: 11,
                        name: "淋巴按摩",
                        price: '$110 + GST/55分钟'
                    },
                    {
                        id: 12,
                        name: "热石按摩",
                        price: '$150 + GST/75分钟'
                    }
                ]
            }
        ]
    }
}

export default priceInfo;
